module.exports = __webpack_public_path__ + "2d1922c1df7b54c6513be3ebdf2702eb.svg";


//////////////////
// WEBPACK FOOTER
// ../images/admin/approval_queues/icons/icon-redx.svg
// module id = 986
// module chunks = 69